<div class="get-it-modal-dialog p-4" data-automation-id="get-it-modal-dialog">
  <app-modal-header
    title="{{ 'Request Physical Version' | translate }}"
    titleId="get-it-modal-title"
    closeId="close-get-it-dialog-btn"
    (close)="onClose()"
  >
  </app-modal-header>
  <div class="modal-body">
    <form [formGroup]="getItForm" class="get-it-form" (ngSubmit)="onSubmit()">
      <app-pickup-location-select
        formControlName="pickupLocation"
        [pickupLocations]="pickupLocations"
        [selectedLocationCode]="selectedLocationCode"
        (codeChanging)="changePickupLocation($event)"
        [dataAutomationId]="'pickupLocationDropdown'"
      >
      </app-pickup-location-select>
      <app-pickup-volume-select
        formControlName="volume"
        [volumes]="volumes"
        [selectedVolumeCode]="selectedLocationCode"
        (codeChanging)="changeVolume($event)"
        [dataAutomationId]="'volumeDropdown'"
      >
      </app-pickup-volume-select>
      <label
        id="note-label"
        for="note-location"
        data-automation-id="note-label"
        class="note__label"
      >
        {{ "Note" | translate }}
      </label>
      <input
        formControlName="note"
        [attr.aria-invalid]="noteControl.invalid && noteControl.touched"
        [class.is-invalid]="noteControl.invalid && noteControl.touched"
        class="note-input"
        aria-labelledby="edit-note"
        aria-required="false"
        data-automation-id="edit-note"
        placeholder="Write note"
        type="text"
      />
      <section class="actions mt-4">
        <ins-bs-checkbox
          [class.card-element-hidden]="false"
          data-automation-id="limit-to-available-checkbox"
          (change)="(changeLimitToAvailable)"
          [checked]="false"
          [ariaLabelledby]="'limit-to-available'"
          [containerClass]="['mr-1 limit-label-container']"
        >
          <span class="limit-label">{{ "Limit Search To Available Items" }}</span>
        </ins-bs-checkbox>
        <div class="buttons">
          <button
            type="button"
            class="ins-buttons button-secondary flint reset-button"
            (click)="onReset()"
            [disabled]="isLoading$ | async"
            data-automation-id="cancel-get-it-btn"
          >
            <span>Reset</span>
            <img src="../../../../assets/reset.svg" class="btn-icon" />
          </button>
          <button
            class="ins-buttons button-primary flint"
            type="submit"
            [disabled]="isFormDisabled || (this.isLoading$ | async)"
            data-automation-id="confirm-get-it-btn"
          >
            <span>Send</span>
            <img src="../../../../assets/send.svg" class="btn-icon"/>
          </button>
        </div>
      </section>
    </form>
  </div>
</div>
